import styled from 'styled-components'

export default styled.div`
  background-color: ${(props) => props.theme.tokens.canvas};
  .card {
    padding: 8px 16px;
    a {
      display: block;
    }
  }

  .active {
    background-color: ${(props) => props.theme.tokens.surface};
  }
`
